/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { PharmacyIndentStatus } from 'app/shared/model/enumerations/pharmacy-indent-status.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { PharmacyIndentType } from 'app/shared/model/enumerations/pharmacy-indent-type.model';
import { SupplierType } from 'app/shared/model/enumerations/supplier-type.model';
import { ConsumerType } from 'app/shared/model/enumerations/consumer-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-external-order.reducer';

export const PharmacyExternalOrderUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyExternalOrderEntity = useAppSelector(state => state.pharmacyExternalOrder.entity);
  const loading = useAppSelector(state => state.pharmacyExternalOrder.loading);
  const updating = useAppSelector(state => state.pharmacyExternalOrder.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyExternalOrder.updateSuccess);
  const pharmacyIndentStatusValues = Object.keys(PharmacyIndentStatus);
  const pharmacyAddedByTypeValues = Object.keys(PharmacyAddedByType);
  const pharmacyIndentTypeValues = Object.keys(PharmacyIndentType);
  const supplierTypeValues = Object.keys(SupplierType);
  const consumerTypeValues = Object.keys(ConsumerType);

  const handleClose = () => {
    navigate(`/pharmacy-external-order${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...pharmacyExternalOrderEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'REQUESTED',
          addedByType: 'PHARMACY',
          modifiedByType: 'PHARMACY',
          fulfilledByType: 'PHARMACY',
          orderDirection: 'REQUEST',
          supplierIdType: 'PHARMACY',
          consumerType: 'PHARMACY',
          createdByType: 'PHARMACY',
          ...pharmacyExternalOrderEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyExternalOrder.home.createOrEditLabel" data-cy="PharmacyExternalOrderCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.home.createOrEditLabel">
              Create or edit a PharmacyExternalOrder
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-external-order-id"
                  label={translate('tinyMedicRestApp.pharmacyExternalOrder.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.status')}
                id="pharmacy-external-order-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {pharmacyIndentStatusValues.map(pharmacyIndentStatus => (
                  <option value={pharmacyIndentStatus} key={pharmacyIndentStatus}>
                    {translate(`tinyMedicRestApp.PharmacyIndentStatus.${pharmacyIndentStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.active')}
                id="pharmacy-external-order-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.cursor')}
                id="pharmacy-external-order-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.lastUpdated')}
                id="pharmacy-external-order-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.microSec')}
                id="pharmacy-external-order-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.timestampEntry')}
                id="pharmacy-external-order-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.addedById')}
                id="pharmacy-external-order-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.modifiedById')}
                id="pharmacy-external-order-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.fulfilledById')}
                id="pharmacy-external-order-fulfilledById"
                name="fulfilledById"
                data-cy="fulfilledById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.addedByType')}
                id="pharmacy-external-order-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.modifiedByType')}
                id="pharmacy-external-order-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.fulfilledByType')}
                id="pharmacy-external-order-fulfilledByType"
                name="fulfilledByType"
                data-cy="fulfilledByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.orderDirection')}
                id="pharmacy-external-order-orderDirection"
                name="orderDirection"
                data-cy="orderDirection"
                type="select"
              >
                {pharmacyIndentTypeValues.map(pharmacyIndentType => (
                  <option value={pharmacyIndentType} key={pharmacyIndentType}>
                    {translate(`tinyMedicRestApp.PharmacyIndentType.${pharmacyIndentType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.supplierId')}
                id="pharmacy-external-order-supplierId"
                name="supplierId"
                data-cy="supplierId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.supplierIdType')}
                id="pharmacy-external-order-supplierIdType"
                name="supplierIdType"
                data-cy="supplierIdType"
                type="select"
              >
                {supplierTypeValues.map(supplierType => (
                  <option value={supplierType} key={supplierType}>
                    {translate(`tinyMedicRestApp.SupplierType.${supplierType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.consumerId')}
                id="pharmacy-external-order-consumerId"
                name="consumerId"
                data-cy="consumerId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.consumerType')}
                id="pharmacy-external-order-consumerType"
                name="consumerType"
                data-cy="consumerType"
                type="select"
              >
                {consumerTypeValues.map(consumerType => (
                  <option value={consumerType} key={consumerType}>
                    {translate(`tinyMedicRestApp.ConsumerType.${consumerType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.createdById')}
                id="pharmacy-external-order-createdById"
                name="createdById"
                data-cy="createdById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyExternalOrder.createdByType')}
                id="pharmacy-external-order-createdByType"
                name="createdByType"
                data-cy="createdByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-external-order" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyExternalOrderUpdate;
